import { render, staticRenderFns } from "./MealSkuLink.vue?vue&type=template&id=a10afb2a&"
import script from "./MealSkuLink.vue?vue&type=script&lang=js&"
export * from "./MealSkuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports